/* libs */
import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as LookupsActions from "../../actions/lookupsActions";
import * as constants from "../../constants";

const getCulturesLogic = createLogic({
	type: ActionTypes.GET_CULTURES,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		//TODO: dispatch action for creating a loader
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});

				api.get("/lookups/cultures")
					.then(res => {
						//TODO: dispatch action for stopping loader
						dispatch(LookupsActions.getCulturesSuccess(res.data));
						done();
					})
					.catch(error => {
						//TODO: dispatch action for stopping loader
						dispatch(LookupsActions.getCulturesFailure(error));
						done();
					});
			});
	},
});

export default [getCulturesLogic];
